import { __awaiter, __generator } from "tslib";
import { importPolyfill } from "./importPolyfill";
function createTextEncoder(useNativeEncoder) {
    return __awaiter(this, void 0, void 0, function () {
        var polyfill;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (useNativeEncoder) {
                        return [2 /*return*/, new TextEncoder()];
                    }
                    return [4 /*yield*/, importPolyfill()];
                case 1:
                    polyfill = _a.sent();
                    return [2 /*return*/, new polyfill.TextEncoderLite()];
            }
        });
    });
}
export function encode(toEncode) {
    return __awaiter(this, void 0, void 0, function () {
        var useNativeEncoder, encoder;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    useNativeEncoder = "TextEncoder" in window;
                    return [4 /*yield*/, createTextEncoder(useNativeEncoder)];
                case 1:
                    encoder = _a.sent();
                    return [2 /*return*/, encoder.encode(toEncode)];
            }
        });
    });
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW5jb2RlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2VuY29kZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsT0FBTyxFQUFFLGNBQWMsRUFBRSxNQUFNLGtCQUFrQixDQUFDO0FBRWxELFNBQWUsaUJBQWlCLENBQzlCLGdCQUF5Qjs7Ozs7O29CQUV6QixJQUFJLGdCQUFnQixFQUFFLENBQUM7d0JBQ3JCLHNCQUFPLElBQUksV0FBVyxFQUFFLEVBQUM7b0JBQzNCLENBQUM7b0JBRWdCLHFCQUFNLGNBQWMsRUFBRSxFQUFBOztvQkFBakMsUUFBUSxHQUFHLFNBQXNCO29CQUV2QyxzQkFBTyxJQUFJLFFBQVEsQ0FBQyxlQUFlLEVBQUUsRUFBQzs7OztDQUN2QztBQUVELE1BQU0sVUFBZ0IsTUFBTSxDQUFDLFFBQWdCOzs7Ozs7b0JBQ3JDLGdCQUFnQixHQUFHLGFBQWEsSUFBSSxNQUFNLENBQUM7b0JBQ2pDLHFCQUFNLGlCQUFpQixDQUFDLGdCQUFnQixDQUFDLEVBQUE7O29CQUFuRCxPQUFPLEdBQUcsU0FBeUM7b0JBRXpELHNCQUFPLE9BQU8sQ0FBQyxNQUFNLENBQUMsUUFBUSxDQUFDLEVBQUM7Ozs7Q0FDakMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBpbXBvcnRQb2x5ZmlsbCB9IGZyb20gXCIuL2ltcG9ydFBvbHlmaWxsXCI7XG5cbmFzeW5jIGZ1bmN0aW9uIGNyZWF0ZVRleHRFbmNvZGVyKFxuICB1c2VOYXRpdmVFbmNvZGVyOiBib29sZWFuXG4pOiBQcm9taXNlPFRleHRFbmNvZGVyPiB7XG4gIGlmICh1c2VOYXRpdmVFbmNvZGVyKSB7XG4gICAgcmV0dXJuIG5ldyBUZXh0RW5jb2RlcigpO1xuICB9XG5cbiAgY29uc3QgcG9seWZpbGwgPSBhd2FpdCBpbXBvcnRQb2x5ZmlsbCgpO1xuXG4gIHJldHVybiBuZXcgcG9seWZpbGwuVGV4dEVuY29kZXJMaXRlKCk7XG59XG5cbmV4cG9ydCBhc3luYyBmdW5jdGlvbiBlbmNvZGUodG9FbmNvZGU6IHN0cmluZyk6IFByb21pc2U8VWludDhBcnJheT4ge1xuICBjb25zdCB1c2VOYXRpdmVFbmNvZGVyID0gXCJUZXh0RW5jb2RlclwiIGluIHdpbmRvdztcbiAgY29uc3QgZW5jb2RlciA9IGF3YWl0IGNyZWF0ZVRleHRFbmNvZGVyKHVzZU5hdGl2ZUVuY29kZXIpO1xuXG4gIHJldHVybiBlbmNvZGVyLmVuY29kZSh0b0VuY29kZSk7XG59XG4iXX0=